module.exports = __webpack_public_path__ + "components/flag/static/square/mv-bab5572edcd6e04a0a7155b3db939416.svg";